const r=r=>r.reduce(((r,c)=>Array.isArray(c)?r.concat(c):(r.push(c),r)),[]);export{r as flatten};
//# sourceMappingURL=flatten.js.map
